/**
 * Datentypen der Zeiterfassung, siehe docs/zeiterfassung-api.md.
 * Gerundet wird ausschließlich im Backend, das Frontend zeigt nur an.
 */

export type Buchung = {
    id: number,
    user: string,
    name: string,
    tag: string,
    tagFormatiert: string,
    kommen: number,
    kommenZeit: string,
    kommenDatumZeit: string,
    gehen: number | null,
    gehenZeit: string,
    gehenDatumZeit: string,
    offen: boolean,
    minuten: number,
    stunden: number,
    stundenFormatiert: string,
    kommentar: string,
    state: number,
    modifiedBy: string
}

export type ZeitStatus = {
    user: string,
    name: string,
    canEditZeiten: boolean,
    anwesend: boolean,
    gebucht: boolean,
    offeneBuchung: Buchung | null
}

export type MeInfo = {
    user: string,
    name: string,
    canEditZeiten: boolean
}

export type ZeitStoreData = {
    id?: string,
    user: string,
    kommen: string,
    gehen: string | null,
    kommentar: string,
    von?: string,
    bis?: string
}

/** Datum als yyyy-MM-dd, bewusst lokal und nicht über toISOString (UTC). */
export function isoDate(date: Date): string {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return date.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
}

export function heute(): string {
    return isoDate(new Date());
}

export function monatsErster(): string {
    const now = new Date();
    return isoDate(new Date(now.getFullYear(), now.getMonth(), 1));
}

/** "2026-03-10 08:15" -> "2026-03-10T08:15" für input type="datetime-local". */
export function toInputValue(datumZeit: string): string {
    if (!datumZeit)
        return '';
    return datumZeit.replace(' ', 'T');
}

/**
 * Minuten als Dezimalstunden, exakt wie ZeitUtil.formatStunden im Backend,
 * damit Summen in der Liste und im PDF übereinstimmen.
 */
export function formatStunden(minuten: number): string {
    let stunden = Math.floor(minuten / 60);
    let hundertstel = Math.round((minuten % 60) * 100 / 60);
    if (hundertstel === 100) {
        stunden++;
        hundertstel = 0;
    }
    return stunden + ',' + (hundertstel < 10 ? '0' : '') + hundertstel;
}

export function summeMinuten(zeiten: Array<Buchung>): number {
    return zeiten.reduce((sum, z) => sum + z.minuten, 0);
}

/** Benutzerkennungen der geladenen Buchungen, für die Auswahl in der Liste. */
export function benutzerVon(zeiten: Array<Buchung>): Array<string> {
    const users: Array<string> = [];
    for (let z of zeiten)
        if (users.indexOf(z.user) === -1)
            users.push(z.user);
    return users.sort();
}
